module.exports = __webpack_public_path__ + "static/media/IMG_3055.40673f1e.JPG";